__turbopack_context__.v({
  "actionList": "climate-module__dq5Krq__actionList",
  "actions": "climate-module__dq5Krq__actions",
  "actionsNumber": "climate-module__dq5Krq__actionsNumber",
  "altitude": "climate-module__dq5Krq__altitude",
  "answerGrid": "climate-module__dq5Krq__answerGrid",
  "bigNumber": "climate-module__dq5Krq__bigNumber",
  "caption": "climate-module__dq5Krq__caption",
  "chart": "climate-module__dq5Krq__chart",
  "chartHead": "climate-module__dq5Krq__chartHead",
  "chartSmall": "climate-module__dq5Krq__chartSmall",
  "coverage": "climate-module__dq5Krq__coverage",
  "dark": "climate-module__dq5Krq__dark",
  "diagramCaption": "climate-module__dq5Krq__diagramCaption",
  "dot": "climate-module__dq5Krq__dot",
  "editorialCredit": "climate-module__dq5Krq__editorialCredit",
  "empty": "climate-module__dq5Krq__empty",
  "evidenceKey": "climate-module__dq5Krq__evidenceKey",
  "evidenceType": "climate-module__dq5Krq__evidenceType",
  "eyebrow": "climate-module__dq5Krq__eyebrow",
  "faq": "climate-module__dq5Krq__faq",
  "feedbackGrid": "climate-module__dq5Krq__feedbackGrid",
  "feedbackSteps": "climate-module__dq5Krq__feedbackSteps",
  "feedbackVisual": "climate-module__dq5Krq__feedbackVisual",
  "field": "climate-module__dq5Krq__field",
  "heatmap": "climate-module__dq5Krq__heatmap",
  "hero": "climate-module__dq5Krq__hero",
  "heroAside": "climate-module__dq5Krq__heroAside",
  "heroChart": "climate-module__dq5Krq__heroChart",
  "heroGrid": "climate-module__dq5Krq__heroGrid",
  "intro": "climate-module__dq5Krq__intro",
  "jump": "climate-module__dq5Krq__jump",
  "legend": "climate-module__dq5Krq__legend",
  "localContext": "climate-module__dq5Krq__localContext",
  "localControls": "climate-module__dq5Krq__localControls",
  "loop": "climate-module__dq5Krq__loop",
  "monthTile": "climate-module__dq5Krq__monthTile",
  "mountain": "climate-module__dq5Krq__mountain",
  "nav": "climate-module__dq5Krq__nav",
  "note": "climate-module__dq5Krq__note",
  "number": "climate-module__dq5Krq__number",
  "overview": "climate-module__dq5Krq__overview",
  "page": "climate-module__dq5Krq__page",
  "panel": "climate-module__dq5Krq__panel",
  "panelWide": "climate-module__dq5Krq__panelWide",
  "pathways": "climate-module__dq5Krq__pathways",
  "policyStrip": "climate-module__dq5Krq__policyStrip",
  "rangeAxis": "climate-module__dq5Krq__rangeAxis",
  "rangeBand": "climate-module__dq5Krq__rangeBand",
  "rangeList": "climate-module__dq5Krq__rangeList",
  "rangeName": "climate-module__dq5Krq__rangeName",
  "rangePoint": "climate-module__dq5Krq__rangePoint",
  "rangeRow": "climate-module__dq5Krq__rangeRow",
  "rangeTrack": "climate-module__dq5Krq__rangeTrack",
  "rangeValue": "climate-module__dq5Krq__rangeValue",
  "readingCard": "climate-module__dq5Krq__readingCard",
  "readingGrid": "climate-module__dq5Krq__readingGrid",
  "readingLinks": "climate-module__dq5Krq__readingLinks",
  "regionSelected": "climate-module__dq5Krq__regionSelected",
  "regionText": "climate-module__dq5Krq__regionText",
  "reportFeature": "climate-module__dq5Krq__reportFeature",
  "reportYear": "climate-module__dq5Krq__reportYear",
  "reviewed": "climate-module__dq5Krq__reviewed",
  "riskAxis": "climate-module__dq5Krq__riskAxis",
  "riskBar": "climate-module__dq5Krq__riskBar",
  "riskLabel": "climate-module__dq5Krq__riskLabel",
  "riskRow": "climate-module__dq5Krq__riskRow",
  "riskTrack": "climate-module__dq5Krq__riskTrack",
  "section": "climate-module__dq5Krq__section",
  "sectionHead": "climate-module__dq5Krq__sectionHead",
  "segments": "climate-module__dq5Krq__segments",
  "small": "climate-module__dq5Krq__small",
  "source": "climate-module__dq5Krq__source",
  "sourceItem": "climate-module__dq5Krq__sourceItem",
  "sourceList": "climate-module__dq5Krq__sourceList",
  "sportTakeaway": "climate-module__dq5Krq__sportTakeaway",
  "stepNumber": "climate-module__dq5Krq__stepNumber",
  "surfEcosystems": "climate-module__dq5Krq__surfEcosystems",
  "surfJourney": "climate-module__dq5Krq__surfJourney",
  "tableDetails": "climate-module__dq5Krq__tableDetails",
  "tableScroll": "climate-module__dq5Krq__tableScroll",
  "threeCol": "climate-module__dq5Krq__threeCol",
  "topline": "climate-module__dq5Krq__topline",
  "twoCol": "climate-module__dq5Krq__twoCol",
  "viewLink": "climate-module__dq5Krq__viewLink",
  "waffle": "climate-module__dq5Krq__waffle",
  "waveArrow": "climate-module__dq5Krq__waveArrow",
  "waveDiagram": "climate-module__dq5Krq__waveDiagram",
  "wrap": "climate-module__dq5Krq__wrap",
});
